"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownResponse = exports.NotAuthorized = exports.Forbidden = exports.ConnectionError = exports.BadRequest = void 0;
var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _common = require("@webex/common");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Exception thrown when a websocket gets closed
 */
var ConnectionError = /*#__PURE__*/function (_Exception) {
  (0, _inherits2.default)(ConnectionError, _Exception);
  var _super = _createSuper(ConnectionError);
  function ConnectionError() {
    (0, _classCallCheck2.default)(this, ConnectionError);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(ConnectionError, [{
    key: "parse",
    value:
    /**
     * @param {CloseEvent} event
     * @returns {string}
     */
    function parse() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      (0, _defineProperties.default)(this, {
        code: {
          value: event.code
        },
        reason: {
          value: event.reason
        }
      });
      return event.reason;
    }
  }]);
  return ConnectionError;
}(_common.Exception);
/**
 * thrown for CloseCode 4400
 */
exports.ConnectionError = ConnectionError;
(0, _defineProperty2.default)(ConnectionError, "defaultMessage", 'Failed to connect to socket');
var UnknownResponse = /*#__PURE__*/function (_ConnectionError) {
  (0, _inherits2.default)(UnknownResponse, _ConnectionError);
  var _super2 = _createSuper(UnknownResponse);
  function UnknownResponse() {
    (0, _classCallCheck2.default)(this, UnknownResponse);
    return _super2.apply(this, arguments);
  }
  return (0, _createClass2.default)(UnknownResponse);
}(ConnectionError);
/**
 * thrown for CloseCode 4400
 */
exports.UnknownResponse = UnknownResponse;
(0, _defineProperty2.default)(UnknownResponse, "defaultMessage", 'UnknownResponse is produced by IE when we receive a 4XXX. You probably want to treat this like a NotFound');
var BadRequest = /*#__PURE__*/function (_ConnectionError2) {
  (0, _inherits2.default)(BadRequest, _ConnectionError2);
  var _super3 = _createSuper(BadRequest);
  function BadRequest() {
    (0, _classCallCheck2.default)(this, BadRequest);
    return _super3.apply(this, arguments);
  }
  return (0, _createClass2.default)(BadRequest);
}(ConnectionError);
/**
 * thrown for CloseCode 4401
 */
exports.BadRequest = BadRequest;
(0, _defineProperty2.default)(BadRequest, "defaultMessage", 'BadRequest usually implies an attempt to use service account credentials');
var NotAuthorized = /*#__PURE__*/function (_ConnectionError3) {
  (0, _inherits2.default)(NotAuthorized, _ConnectionError3);
  var _super4 = _createSuper(NotAuthorized);
  function NotAuthorized() {
    (0, _classCallCheck2.default)(this, NotAuthorized);
    return _super4.apply(this, arguments);
  }
  return (0, _createClass2.default)(NotAuthorized);
}(ConnectionError);
/**
 * thrown for CloseCode 4403
 */
exports.NotAuthorized = NotAuthorized;
(0, _defineProperty2.default)(NotAuthorized, "defaultMessage", 'Please refresh your access token');
var Forbidden = /*#__PURE__*/function (_ConnectionError4) {
  (0, _inherits2.default)(Forbidden, _ConnectionError4);
  var _super5 = _createSuper(Forbidden);
  function Forbidden() {
    (0, _classCallCheck2.default)(this, Forbidden);
    return _super5.apply(this, arguments);
  }
  return (0, _createClass2.default)(Forbidden);
}(ConnectionError); // /**
//  * thrown for CloseCode 4404
//  */
// export class NotFound extends ConnectionError {
//   static defaultMessage = `Please refresh your Mercury registration (typically via a WDM refresh)`;
// }
exports.Forbidden = Forbidden;
(0, _defineProperty2.default)(Forbidden, "defaultMessage", 'Forbidden usually implies these credentials are not entitled for Webex');
//# sourceMappingURL=errors.js.map
